import { useTranslate } from '@tolgee/react';
import { Button, ButtonProps } from 'antd';
import FacebookLangSelect from 'components/Langs/FacebookLangSelect';
import { RegionLangSelect } from 'components/Langs/RegionLangSelect';

interface TranslateButtonProps {
  targetLang: General.Language;
  onChange: (lang: General.Language) => void;
  translating: boolean;
  trimInput: string;
  onTranslateClick: () => void;
  size?: ButtonProps['size'];
  region: Conversation.Conversation['region'];
  channel: Conversation.Conversation['channel'];
  controlStatus: Conversation.Conversation['controlStatus'];
}

export const TranslateButton = (props: TranslateButtonProps) => {
  const {
    channel,
    region,
    controlStatus,
    targetLang,
    onChange,
    translating,
    trimInput,
    onTranslateClick,
    size,
  } = props;

  const { t } = useTranslate();

  return (
    <Button.Group>
      {channel === 'FACEBOOK' ? (
        <FacebookLangSelect size={size} value={targetLang} onChange={onChange} />
      ) : (
        <RegionLangSelect size={size} region={region} value={targetLang} onChange={onChange} />
      )}
      <Button
        loading={translating}
        disabled={!controlStatus || !trimInput}
        onClick={onTranslateClick}
        size={size}
      >
        {t('common.action.translate')}
      </Button>
    </Button.Group>
  );
};
